import { useT } from "@/i18n/LangProvider";
import { useQuoteHref } from "@/i18n/routing";

export default function Process() {
  const { t } = useT();
  const quoteHref = useQuoteHref();
  const steps = t("process.steps") || [];

  return (
    <section
      id="processo"
      data-testid="process-section"
      className="section"
      style={{ background: "var(--navy-mid)" }}
    >
      <div className="section-inner">
        <p className="eyebrow fade-up">{t("process.eyebrow")}</p>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-4 mb-16 fade-up">
          {t("process.title1")}{" "}
          <em className="text-[color:var(--gold-light)]">
            {t("process.title_em")}
          </em>
        </h2>

        <div className="space-y-2">
          {steps.map((s, i) => (
            <div
              key={i}
              className="grid grid-cols-1 md:grid-cols-[120px_1fr_180px] gap-6 md:gap-8 items-start py-10 border-t border-[rgba(184,150,46,0.18)] fade-up"
              data-testid={`process-step-${i}`}
            >
              <div className="font-mono-brand text-[color:var(--gold-light)] text-xl md:text-2xl border border-[rgba(184,150,46,0.4)] inline-flex items-center justify-center px-5 py-3 self-start">
                {String(i + 1).padStart(2, "0")}
              </div>
              <div>
                <h3 className="font-serif text-2xl md:text-3xl text-[color:var(--white)] mb-3">
                  {s.title}
                </h3>
                <p className="font-sans-brand text-[color:var(--muted-white)] leading-relaxed max-w-2xl">
                  {s.body}
                </p>
              </div>
              <div className="font-mono-brand text-xs text-[color:var(--gold-light)] md:text-right md:pt-3">
                {s.time}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 fade-up">
          <a
            href={quoteHref}
            className="btn-pill btn-pill-gold"
            data-testid="process-cta"
          >
            {t("process.cta")}
          </a>
        </div>
      </div>
    </section>
  );
}
